import PropTypes from 'prop-types';
import React, {Component} from 'react';

import {_} from '../../../utils/i18n';

import LessonContainer from './LessonContainer';

const DefaultMessageLabel = _('Thank you for your information.');
const RedirectLabel = _('You will be redirected to the home page.');

export const redirect = to => {
    if (location.protocol === 'file:') {
        window.location = `${to}.html`;
    } else {
        window.location = `/${to}/`;
    }
};

/**
 * Renders the complete message.
 */
class LessonComplete extends Component {

    constructor(props) {
        super(props);

        this.state = {
            seconds: props.seconds,
        };

        this.redirect = this.redirect.bind(this);
    }

    render() {
        const {className, message, children} = this.props;

        return (
            <LessonContainer className={className}>
                <div className="card-panel lesson-complete">
                    <p className="intro">
                        {message}
                    </p>
                    <p className="time">{RedirectLabel.interpolate(this.state)}</p>
                    {children}
                </div>
            </LessonContainer>
        );
    }

    componentDidMount() {
        this.interval = setInterval(() => this.setState(state => ({seconds: state.seconds - 1})), 1000);
    }

    redirect() {
        const {onCompleted, redirectTo} = this.props;

        if (onCompleted) onCompleted();

        return redirect(redirectTo);
    }

    componentDidUpdate() {
        if (this.state.seconds === 0 && this.interval) {
            clearInterval(this.interval);

            this.interval = null;

            this.redirect();
        }
    }
}


LessonComplete.defaultProps = {
    message: DefaultMessageLabel,
    className: null,
    children: null,
    seconds: 5,
    onCompleted: null,
    redirectTo: 'home',
};

LessonComplete.propTypes = {
    className: PropTypes.string,
    message: PropTypes.string,
    children: PropTypes.node,
    seconds: PropTypes.number,
    onCompleted: PropTypes.func,
    redirectTo: PropTypes.string,
};

export default LessonComplete;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/LessonComplete.js